

    <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header">User Permissions</div> 
      <div class="col-10 justify-content-center">
      <div class="card-body">

<mat-tab-group animationDuration="500ms">
  <mat-tab label="Module Permissions">

          <br>
          <div class="input-group">
            <input  name="id" readonly [(ngModel)]="id"  class="form-control"    type="hidden">
            </div>

          <div class="col-12">
            <mat-form-field>
              <mat-label [ngClass]="{'dark-bg' : isDark }">Select User</mat-label>
              <mat-select [(ngModel)]="selectedUser" (ngModelChange)="getUserPermissionByUserName()">
                <mat-option>None</mat-option>
                <mat-option *ngFor="let user of userList" [value]="user.UserName">
                  {{user.UserName}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-checkbox class="float-right"  (change)="selectAllPermissioncheckedChange()" [(ngModel)]="selectAllPermission">Select All</mat-checkbox>     
          </div>
          
          <mat-selection-list #list [(ngModel)]="selectedUI">
            <mat-list-option *ngFor="let item of typesOfUI" [value]="item" [ngClass]="{'dark-bg' : isDark }">
                {{item}}
            </mat-list-option>
          </mat-selection-list>
          

          <button type="button" class="btn btn-success" (click)="saveButtonClick()"> 
            <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            Save
            </button>
            <button type="button" class="btn btn-danger ml-2" (click)="deleteButtonClick()"> Delete  </button>


  </mat-tab>

  <mat-tab label="Control Permissions">
    <br>
    <div class="col-12">
      <mat-form-field>
        <mat-label [ngClass]="{'dark-bg' : isDark }">Select User</mat-label>
        <mat-select [(ngModel)]="selectedUserForControl" (ngModelChange)="getUserControlPermissionByUserName()">
          <mat-option>None</mat-option>
          <mat-option *ngFor="let user of userList" [value]="user.UserName">
            {{user.UserName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      <mat-checkbox class="float-right"  (change)="selectAllcheckedChange()" [(ngModel)]="selectAll">Select All</mat-checkbox>     
  
    </div>

    <table class="table table-sm mt-2 table-bordered" [ngClass]="{'dark-bg' : isDark }">  
      <thead class="thead-light"  [ngClass]="{'dark-input-field' : isDark }" [ngClass]="{'thead-light' : !isDark }">
          <tr>
            <th style="width: 40%" scope="col">Module</th>
            <th class="text-center" style="width: 15%">Read</th>
            <th class="text-center" style="width: 15%">Create/Update</th>
            <th class="text-center" style="width: 15%" scope="col">Approve</th>
            <th class="text-center" style="width: 15%" scope="col">Delete</th>
          </tr>
        </thead>


      <tbody class="ml-1">                              
            <tr  *ngFor="let item of controlPermissionArray; let i = index">                           
                <td>{{item.module}}</td>
                <td class="p-2 text-center"><mat-checkbox [(ngModel)]="item.read"></mat-checkbox></td>                    
                <td class="p-2 text-center"><mat-checkbox [(ngModel)]="item.create"></mat-checkbox></td>  
                <td class="p-2 text-center"><p *ngIf="item.approve==null">-</p><mat-checkbox *ngIf="item.approve!=null" [(ngModel)]="item.approve"></mat-checkbox></td>  
                <td class="p-2 text-center"><p *ngIf="item.delete==null">-</p><mat-checkbox *ngIf="item.delete!=null" [(ngModel)]="item.delete"></mat-checkbox></td>                                                      
            </tr>  
                                            
      </tbody>
      <br>
      <tfoot>
        <tr>
          <td colspan="5">
            <button type="button" (click)="saveControlPermissionButtonClick()" class="btn btn-success"><i class="fa fa-save"></i> Save</button>
            <button type="button" (click)="deleteControlPermissionButtonClick()" class="btn btn-danger ml-2"><i class="fa fa-trash-alt"></i> Delete</button>
            <button type="button" (click)="clearPanel()" class="btn btn-warning ml-2"><i class="fa fa-refresh"></i> Clear</button>
          </td>
        </tr>   
      </tfoot>
  </table> 

  </mat-tab>
</mat-tab-group>



</div>     
</div>
</div>

    
   




